import { ENV, LocalStorageService, ROUTE } from "@/utils";
import axios from "axios";
import { AuthApi } from "./auth";

export const instance = axios.create({
  baseURL: `${ENV.VITE_BACKEND_API_URL}/v1/`,
  timeout: 50000,
});

instance.interceptors.request.use(
  async (config) => {
    const accessToken = LocalStorageService.getAccessToken();

    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const { message, statusCode } = error.response.data;

    if (
      (message === "invalid token" || message === "invalid signature") &&
      statusCode === 401
    ) {
      LocalStorageService.deleteAuthTokens();
      window.location.href = ROUTE.AUTH_LOGIN;
      return Promise.reject();
    }

    if (message === "jwt expired" && statusCode === 401) {
      originalRequest._retry = true;
      const refreshToken = LocalStorageService.getRefreshToken();

      if (refreshToken) {
        try {
          const newTokens = await AuthApi.refreshLogin();

          LocalStorageService.setAccessToken(newTokens.accessToken);
          LocalStorageService.setRefreshToken(newTokens.refreshToken);

          originalRequest.headers["Authorization"] =
            `Bearer ${newTokens.accessToken}`;

          return axios(originalRequest);
        } catch (refreshError) {
          LocalStorageService.deleteAuthTokens();
          window.location.href = ROUTE.AUTH_LOGIN;

          console.error("Token refresh failed", refreshError);
          return Promise.reject(refreshError);
        }
      }
    }
    return Promise.reject(error);
  }
);

export { instance as axios };
